import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-map-marker-yandex",
  "use": "foquz-icon-map-marker-yandex-usage",
  "viewBox": "0 0 17 20",
  "content": "<symbol viewBox=\"0 0 17 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-map-marker-yandex\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.556 1.348a8 8 0 0110.102 12.31c-.377.376-.887.797-1.44 1.253-1.566 1.292-3.47 2.862-3.617 4.489a.6.6 0 01-1.2 0c-.148-1.627-2.052-3.197-3.618-4.49-.552-.455-1.063-.876-1.44-1.253A8 8 0 013.556 1.348zM9.98 9.98a2.8 2.8 0 11-3.96-3.96 2.8 2.8 0 013.96 3.96z\" fill=\"#F43\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol